var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectSeatSmallest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.774 7.544H9.43c.174 0 .314-.141.314-.315V1.572a.314.314 0 00-.314-.314H3.774a.314.314 0 00-.315.314v5.657c0 .174.141.315.315.315zM9.43 8.8c.868 0 1.572-.704 1.572-1.572V1.572C11.003.704 10.299 0 9.43 0H3.774c-.868 0-1.572.704-1.572 1.572v5.657c0 .868.704 1.572 1.572 1.572H9.43z",
    fill: "#CACACA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.943 8.805V4.4H13.2v4.42c0 .6-.423.997-.817 1.235-.41.247-.95.427-1.537.561-1.184.27-2.73.393-4.25.383-1.52-.009-3.064-.149-4.244-.424-.585-.136-1.122-.314-1.527-.551C.446 9.803 0 9.419 0 8.82V4.4h1.257v4.385c.018.023.07.076.202.153.247.145.643.288 1.178.413 1.06.247 2.502.383 3.967.391 1.465.01 2.906-.11 3.961-.351.534-.122.926-.266 1.169-.413.151-.091.197-.152.21-.173zm.004-.01l-.002.006.002-.006zM1.248 8.771l.002.004-.002-.004z",
    fill: "#CACACA"
  })));
}
export default SvgSelectSeatSmallest;